import type { ReactNode } from 'react';

export const symbol_directions_bike: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M195-80q-81 0-138-57T0-275q0-81 57-138t138-57q81 0 138 57t57 138q0 81-57 138T195-80Zm96-99q39-39 39-96t-39-96q-39-39-96-39t-96 39q-39 39-39 96t39 96q39 39 96 39t96-39Zm242-481L422-548l72 78q8 8 12 19t4 22v193q0 13-8.5 21.5T480-206q-13 0-21.5-8.5T450-236v-170L315-525q-11-9-16-22t-5-27q0-14 5.5-26t15.5-22l119-119q11-11 24.5-16t28.5-5q15 0 28.5 5t24.5 16l78 78q26 26 58.5 43t68.5 22q12 2 19.5 12t5.5 22q-2 12-12 19.5t-22 5.5q-46-6-88-27t-75-54l-40-40Zm34.5-115.5Q546-797 546-827t21.5-51.5Q589-900 619-900t51.5 21.5Q692-857 692-827t-21.5 51.5Q649-754 619-754t-51.5-21.5ZM765-80q-81 0-138-57t-57-138q0-81 57-138t138-57q81 0 138 57t57 138q0 81-57 138T765-80Zm96-99q39-39 39-96t-39-96q-39-39-96-39t-96 39q-39 39-39 96t39 96q39 39 96 39t96-39Z"
		/>
	</svg>
);
